<template lang="pug">
    //- .property-value(v-if="type === 'unit'")
    //-     label {{ label }}
    //-     span.value {{ value }}
    //-         span.unit {{ unit }}
    //- //- .property-value(v-else-if="type === 'color'")
    //- //-     label {{ label }}
    //- //-     span.value {{ colorName }}
    //- .property-value(v-else-if="type === 'date'")
    //-     label {{ label }}
    //-     span.value {{ dateValue }}
    //- .property-value(v-else)
    //-     label {{ label }}
    //-     .options(v-if="$listeners && $listeners.click")
    //-         el-button(
    //-             v-for="option in options" :key="option.id"
    //-             :type="selected && selected.id === option.id ? 'primary' : 'info'"
    //-             size="mini"
    //-             @click="$emit('click', property, option.source)"
    //-             :disabled="option.source.disabled"
    //-         ) {{ option.value }}
    //-     span.value(v-else v-html="value")

    .property-value
        label(:class="{ 'button-label': $listeners && $listeners.click }") {{ label }}
        .options(v-if="$listeners && $listeners.click")
            el-button(
                v-for="option in options" :key="option.id"
                :type="selected && selected.id === option.id ? 'primary' : 'info'"
                size="mini"
                @click="$emit('click', property, option.source)"
                :disabled="option.source.disabled"
            )
                template(v-if="type === 'unit'") {{ option.value }}&nbsp;
                    span.unit {{ unit }}
                //- template(v-else-if="type === 'color'") {{ option.value }}
                template(v-else-if="type === 'date'") {{ option.value | timestamp2date(dateformat) }}
                template(v-else) {{ option.value }}
                span.surcharge(v-if="currency && option.surcharge") {{ option.surcharge | moneyFormat(currency) }}
        template(v-else)
            span.value(v-if="type === 'unit'") {{ value }}&nbsp;
                span.unit {{ unit }}
            //- span.value(v-else-if="type === 'color'") {{ colorName }}
            span.value(v-else-if="type === 'date'") {{ dateValue }}
            span.value(v-else v-html="value")
            span.surcharge(v-if="currency && option.surcharge") {{ option.surcharge | moneyFormat(currency) }}
</template>

<script>

import _ from 'lodash'
import { moneyFormat, timestamp2date } from '@/filters';

export default {
    name: 'PropertyPivotValues',
    props: {
        property: {
            type: Object,
            required: true,
        },
        valueOptions: {
            type: Array,
            required: true,
        },
        currency: {
            type: String,
            required: false,
        },
        selected: {
            type: Object,
            required: false,
        },
        language: {
            type: String,
            required: false,
        }
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        type() {
            return _.get(this.property, 'propType.key')
        },
        key() {
            return _.get(this.property, 'key')
        },
        label() {
            let name = _.get(this.property, 'name')

            if (this.language && this.property.translations) {
                 const translation = this.property.translations.find(el => el.language.code === this.language)
                if (translation) name = translation.name
            }

            return name
        },
        field() {
            return _.get(this.property, 'propType.value_field')
        },
        value() {
            let values = []

            this.valueOptions.forEach(el => {
                let value = _.get(el, this.field)

                if (this.language && el.translations) {
                    const translation = el.translations.find(el => el.language.code === this.language)
                    if (translation) value = _.get(translation, this.field)
                }

                if (value) values.push(value)
            })

            return values.join(', ')
        },
        options() {
            let options = []

            this.valueOptions.forEach(el => {
                const value = _.get(el, this.field)
                const surcharge = _.get(el, 'pivot.price.value') || _.get(el, 'price.value')
                if (value) options.push({ id: el.id, value, surcharge, source: el })
            })

            return options
        },
        fieldAlt() {
            return _.get(this.property, 'propType.value_field_alt')
        },
        valueAlt() {
            let values = []

            this.valueOptions.forEach(el => {
                let value = _.get(el, this.fieldAlt)

                if (this.language && el.translations) {
                    const translation = el.translations.find(el => el.language.code === this.language)
                    if (translation) value = _.get(translation, this.fieldAlt)
                }

                if (value) values.push(value)
            })

            return values.join(', ')
        },
        optionsAlt() {
            let options = []

            this.valueOptions.forEach(el => {
                const value = _.get(el, this.fieldAlt)
                const surcharge = _.get(el, 'pivot.price.value') || _.get(el, 'price.value')
                if (value) options.push({ id: el.id, value, surcharge, source: el })
            })

            return options
        },
        dateValue() {
            let values = []

            this.valueOptions.forEach(el => {
                const value = _.get(el, this.field)
                if (value) values.push(timestamp2date(value, this.dateformat))
            })

            return values.join(', ')
        },
        dateformat() {
            let format = this.$t('yyyy-MM-dd')

            switch (this.property.datetype) {
                case 'datetime':
                    format = this.$t('yyyy-MM-dd') + '   HH:mm'
                    break;

                case 'week':
                    format = this.$t('yyyy Week WW')
                    break;

                case 'month':
                    format = this.$t('yyyy-MM')
                    break;

                case 'year':
                    format = this.$t('yyyy')
                    break;
            }

            return format
        },
        // colorName() {
        //     return _.get(this.property, 'value.text')
        // },
        unit() {
            let unit = _.get(this.property, 'unit')

            if (this.language && this.property.translations) {
                 const translation = this.property.translations.find(el => el.language.code === this.language)
                if (translation) unit = translation.unit
            }

            return unit
        },
    }
}
</script>

<style lang="sass" scoped>
.property-value
    label
        font-style: italic
.property-value
    label:not(.button-label):after
        content: ': '

.options
    display: flex
    flex-wrap: wrap
    gap: 4px
    .el-button
        margin: 0
.surcharge
    margin-left: 1ch
    opacity: 0.8
    &:before
        content: '+'
</style>
